import { IconWifi } from '@tabler/icons-react';
import { OfflineIllustration } from '../../assets/illustrations/offline-illustration';
import { useI18n } from '../../locales/i18n-context';
import { useOfflineContext } from '../../context/offline-provider';
import './Offline.css';

/**
 * Offline screen component.
 * Reads `offline` state from OfflineProvider context and renders a full-screen
 * overlay when connectivity is lost. Must be used inside <OfflineProvider>.
 */
export const Offline = () => {
  const { setOffline } = useOfflineContext();
  const { t } = useI18n();

  return (
    <div className="cb-offline-overlay" role="alertdialog" aria-live="assertive">
      <OfflineIllustration />
      <div>
        <h1 className="cb-offline-title">{t('error.offline.title')}</h1>
        <p className="cb-offline-subtitle">{t('error.offline.subtitle')}</p>
        <button
          className="cb-offline-reconnect"
          onClick={() => {
            if (navigator.onLine) setOffline(false);
          }}
        >
          <IconWifi size={16} />
          {t('action.reconnect')}
        </button>
      </div>
    </div>
  );
};
